export default {
  props: {
    story: Object
  }
}
